import { render, staticRenderFns } from "./ProjectFormCard.vue?vue&type=template&id=4d47f73d&scoped=true"
import script from "./ProjectFormCard.vue?vue&type=script&lang=js"
export * from "./ProjectFormCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectFormCard.vue?vue&type=style&index=0&id=4d47f73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47f73d",
  null
  
)

export default component.exports